import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, ComponentFactoryResolver } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromAuth from '../../authentication/store/auth';
import { State } from '../../authentication/store/auth/auth.reducer';
import { AuthToken } from '../../authentication/store/auth';

const NO_URL_PROVIDED = new Error('No url provided');

@Injectable({ providedIn: 'root' })
export class HttpService {
  constructor(public store: Store<any>, protected http: HttpClient) {}

  delete(url: string, options: object = {}): Observable<any> {
    this.checkUrl(url);
    return this.http.delete(url, { ...options }).pipe(catchError(this.handleError));
  }

  get<T>(url: string, options: object = {}): Observable<any> {
    this.checkUrl(url);
    return this.http.get<T>(url, { ...options }).pipe(catchError(this.handleError));
  }

  patch<T>(url: string, body: any = null, options: object = {}): Observable<any> {
    this.checkUrl(url);
    return this.http.patch<T>(url, body, { ...options }).pipe(catchError(this.handleError));
  }

  post<T>(url: string, body: any = null, options: object = {}): Observable<any> {
    this.checkUrl(url);
    return this.http.post<T>(url, body, { ...options }).pipe(catchError(this.handleError));
  }

  put<T>(url: string, body: any = null, options: object = {}): Observable<T> {
    this.checkUrl(url);
    return this.http.put<T>(url, body, { ...options }).pipe(catchError(this.handleError));
  }

  private checkUrl(url: string): Observable<never> {
    if (!url) {
      return this.handleError(NO_URL_PROVIDED);
    }
  }

  private handleError(error: any): Observable<never> {
    return throwError(error.error);
  }

  getFile(url: string, fileName: string, fileExt: string, errorMessage: string = 'Could not download file.'): Observable<void> {
    return this.get(url, {
      observe: 'response',
      responseType: 'blob'
    }).pipe(
      map((res: any) => {
        if (res.status !== 204) {
          // downloadFile(res.body, fileName, fileExt);
        } else {
          throw { message: errorMessage };
        }
      })
    );
  }

  queryStringFromObject(params: any): string {
    const queryString = Object.keys(params)
      .map(key => {
        let value = params[key];

        if (typeof value !== 'boolean' && typeof value !== 'number') {
          // we do not want to pass the string 'null' to the server in the case
          // that the value is null. if we are not evaluating a boolean or number
          // type, then if the value is not truthy pass empty string.
          if (!value) {
            value = '';
          }
        }

        return `${key}=${encodeURIComponent(value)}`;
      })
      .join('&');

    return queryString;
  }
}
